import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { UnsubscribeForm } from "@/components/Modals/NewsletterUnsubscribeModal/components/unsubscribeForm";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

export const NewsletterUnsubscribeModal = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const isLoading = useSelector(CustomerSelectors.isLoading);

    const { close: closeModal } = useModalRouter(
        ModalType.NewsletterUnsubscribe
    );

    const onFormSubmit = async (form: any) => {
        const action = await dispatch(
            CustomerModule.unsubscribeToNewsLetter(form.email)
        );

        if (action.type === CustomerModule.APIStatus.SUCCESS) {
            broadcastMessage({
                id: "newsletter-unsubscribe-success",
                text: t("newsletter.unsubscribe.success"),
                status: "success",
                dismissible: true
            });
        } else {
            broadcastMessage({
                id: "newsletter-unsubscribe-failure",
                text: t("newsletter.unsubscribe.failure"),
                status: "warning",
                dismissible: true
            });
        }

        closeModal();
    };

    return (
        <RouterModal
            modalType={ModalType.NewsletterUnsubscribe}
            title={t("general.newsletterUnsubscribeModal.title")}
            withFooter={false}
        >
            <p className={cn("revert-legacy", "tw:mb-4")}>
                {t("general.newsletterUnsubscribeModal.description")}
            </p>
            <UnsubscribeForm
                isLoading={isLoading}
                onFormSubmit={onFormSubmit}
            />
        </RouterModal>
    );
};
